import React from "react";
import { useTypewriter, Cursor } from "react-simple-typewriter";
import {
  FaGithub,
  FaTwitter,
  FaLinkedinIn,
  FaReact,
  FaEnvelope,
} from "react-icons/fa";
import {
  SiTailwindcss,
  SiVuedotjs,
  SiNextdotjs,
  SiIonic,
  SiNuxtdotjs,
} from "react-icons/si";

const LeftBanner = () => {
  const [text] = useTypewriter({
    words: ["Fullstack Engineer.", "Mobile Developer.", "UI/UX Enthusiast."],
    loop: true,
    typeSpeed: 20,
    deleteSpeed: 10,
    delaySpeed: 2000,
  });
  return (
    <div className="w-full lgl:w-1/2 flex flex-col gap-20">
      <div className="flex flex-col gap-5">
        <h4 className=" text-lg font-normal">WELCOME TO MY WORLD</h4>
        <h1 className="text-6xl font-bold text-white">
          Hi, I'm{" "}
          <span className="text-designColor capitalize">Ime Ekwere</span>
        </h1>
        <h2 className="text-4xl font-bold text-white">
          a <span>{text}</span>
          <Cursor
            cursorBlinking="false"
            cursorStyle="|"
            cursorColor="#ff014f"
          />
        </h2>
        <p className="text-base font-bodyFont leading-6 tracking-wide">
          A seasoned frontend and backend developer with 5 years of experience, I bring a
          wealth of knowledge and expertise to the table. I specialize in
          building intuitive and visually appealing user interfaces for web and mobile, as well as robust backend systems and APIs. I design, I develop, I make. I made this!
        </p>
      </div>
      <div className="flex flex-col xl:flex-row gap-6 lgl:gap-0 justify-between">
        <div>
          <h2 className="text-base uppercase font-titleFont mb-4">
            Find me on
          </h2>
          <div className="flex flex-wrap gap-4">
            <a
              href="mailto:imeekwere15@gmail.com?subject=Hello%20there%20Ime&body=I%20would%20like%20to%20connect."
              target="__blank"
            >
              <span className="bannerIcon">
                <FaEnvelope />
              </span>
            </a>
            <a href="https://github.com/Eddikan" target="__blank">
              <span className="bannerIcon">
                <FaGithub />
              </span>
            </a>
            <a href="https://twitter.com/skinnyeddyy" target="__blank">
              <span className="bannerIcon">
                <FaTwitter />
              </span>
            </a>
            <a
              href="https://www.linkedin.com/in/ime-ekwere-552b9b1b3/"
              target="__blank"
            >
              <span className="bannerIcon">
                <FaLinkedinIn />
              </span>
            </a>
          </div>
        </div>
        <div>
          <h2 className="text-base uppercase font-titleFont mb-4">
            BEST SKILLED IN
          </h2>
          <div className="flex flex-wrap md:grid grid-cols-3 gap-4">
            <span className="bannerIcons">
              <FaReact />
            </span>
            <span className="bannerIcons">
              <SiVuedotjs />
            </span>
            <span className="bannerIcons">
              <SiNextdotjs />
            </span>
            <span className="bannerIcons">
              <SiTailwindcss />
            </span>
            <span className="bannerIcons">
              <SiIonic />
            </span>
            <span className="bannerIcons">
              <SiNuxtdotjs />
            </span>
            {/* Backend skills */}
            <span className="bannerIcons">
              <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg" alt="Node.js" style={{ width: 24, height: 24 }} />
            </span>
            <span className="bannerIcons">
              <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg" alt="Express.js" style={{ width: 24, height: 24 }} />
            </span>
            <span className="bannerIcons">
              <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg" alt="MongoDB" style={{ width: 24, height: 24 }} />
            </span>
            <span className="bannerIcons">
              <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg" alt="PostgreSQL" style={{ width: 24, height: 24 }} />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeftBanner;
